export const TOTAL_QUESTION_COUNT = 12
